export default {
  'privacy.title': 'Privacy Policy',
} as Record<string, string>;
